var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic-btn"},[_c('button',{staticClass:"d-flex justify-center align-center"},[_c('span',{staticClass:"d-block"},[_vm._v("Start mining")]),_c('img',{staticClass:"d-block ml-2",attrs:{"src":require("@/assets/right-arrow.svg")}})])])
}]

export { render, staticRenderFns }